import { useCreateFromJobDataMutation, useUpdateFromJobDataMutation } from "../../features/po/poSlice";
import { useState } from "react";
import Upload from '../../components/Upload';
import { Button, Link, Paper, Stack, Typography } from "@mui/material";

const UploadCSVBox = ({onParse, children}) => {
    const [errorInfo, setErrorInfo] = useState("");

    return <Stack direction="column" sx={{gap:1}}>
        <Upload compact={true} onUpload={(data) => {
            const blob = new Blob([data.data], {type: 'text/plain; charset=utf-8'});
            blob.text().then(text => {
                onParse(text);
            });
        }}>{children}</Upload>
    { errorInfo !== "" && <Typography color="red">{errorInfo}</Typography>}
    </Stack>;
};

export { UploadCSVBox }